/* eslint-disable import/prefer-default-export */

// Story Flow Variables //
// **************************************************** //
export const categories = [
  {
    category: "Feeling",
    title: "Choose Your Feeling",
    subheader: "Is there a feeling or mood you are looking for?",
    options: [
      {
        name: "Empowering",
        description:
          "Boldness and intensity to ignite your inner strength. Compositions with vibrant hues, active brushwork, and powerful imagery that spark self-assurance deep within.",
        images: [
          "6cd25d19-eef1-4579-8f03-0caf6ec46462",
          "f6ceba49-3625-4ea6-a6ba-6a59ec0d6bcd",
          "74755c6e-d1e9-477b-90bc-d05d4cc978f9",
          "a0901c5f-3b1b-403b-a303-8e8170972912",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Dreamy",
        description:
          "Delicate, fanciful imagery to stir flights of imagination. Compositions with soft focus, muted tones, and ethereal elements that transport you to magical dreamscapes.",
        images: [
          "c33dd914-836c-4e19-863d-e98e7a9a4724",
          "2107bdd3-c26c-442a-9875-6c9fe6a3364d",
          "6d113452-da50-40b2-82d4-b95b34c03e99",
          "76345223-9f82-45cc-bfb1-e8371f0e3416",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Energetic",
        description:
          "Electric palettes and dynamic compositions to get your spirit going. Vibrant hues, active brushwork, and sense of style that vitalize with vigor and enthusiasm.",
        images: [
          "3e9d592c-6ee2-4920-bb1d-387aba603415",
          "93862407-c70f-45e6-b157-4231071db1ad",
          "dcf73d28-b6a8-4146-8029-86b85801375c",
          "ba0a6842-de00-4cae-aecf-8409af45ca8b",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Simple",
        description:
          "Restrained palettes and clean compositions to evoke peace. Subtle tones, ample negative space, and minimalist leanings that promote tranquility and contentment.",
        images: [
          "e2a7de77-b3ef-43a7-81b1-37816bee3c34",
          "8c852cb8-f5dd-4821-be58-db7e31414e71",
          "de5cc841-95a2-49f3-961c-b4ff0050c0d6",
          "81372604-c6ee-436c-a0b3-bee3ba4d3aa6",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Joyful",
        description:
          "Sunny palettes and lighthearted imagery that uplift your spirit. Bright colors, smiling figures, and cheerful tableaus that spark joy and positivity.",
        images: [
          "54b11f40-1097-4f2c-9842-8db68c402b39",
          "98f47f30-7029-4326-b1a3-ca26266d4d83",
          "09fbbab6-afcd-4c29-9695-b68e87f520f0",
          "6436d404-e915-4752-9746-f78160083a04",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Peaceful",
        description:
          "Misty earth tones and harmonious compositions to soothe your spirit. Gentle pastels, calming landscapes, and overall balance that whispers of serenity and wellbeing.",
        images: [
          "aa244777-6b2c-4710-9880-809e98184c7d",
          "171d000d-e935-4bd0-80be-c869b85926be",
          "c37c63cf-b15d-415d-8bfb-163f4f70478d",
          "9005e3e3-5718-4238-9dc2-40d7282eba0d",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Nostalgic",
        description:
          "Warm sepia tones and familiar imagery kindle fond memories. Weathered patinas, vintage motifs, and sentimental tableaus rekindle reminiscence and comfort.",
        images: [
          "1f6942fa-b1de-43c5-b73c-28220310733f",
          "b4b6757e-c39f-4605-bef0-1e1e6d165e24",
          "d9cafaf3-2b03-4e64-9a7e-2fea2057ac7f",
          "5ebbc811-8ec0-43f6-911f-3441bc07f974",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Transcendent",
        description:
          "Luminous tones and mystical imagery that expand consciousness. Radiant lights, symbolic elements, and overall expansiveness prompting connection to the divine.",
        images: [
          "b00b2314-3a5d-4cc5-8ba0-003a1f48fe49",
          "5ada3d8c-323c-4dcf-908c-257c37d9f21c",
          "034d8ab3-741e-4fbe-963c-04a734791b18",
          "472d4f5c-60df-4bb5-bb4e-b670f2d24d1d",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
    ],
  },
  {
    category: "Subject",
    title: "Choose Your Subject",
    subheader:
      "The person, place or thing that will be the focal point of your artwork.",
    options: [
      {
        name: "Abstract",
        description:
          "Non-representational art that uses color, line, shape and form to create compositions lacking recognizable objects, focusing instead on emotions, ideas, and visual impact.",
        images: [
          "3e332638-6af9-4410-b179-8c1f24d939ca",
          "5d7162f9-4a1e-467a-81bb-2953a1723ca6",
          "e0beb3ca-969b-4c98-a76d-f1cf6920a30e",
          "7b85b627-4544-4363-bbd5-b5c0330fa904",
        ],
        subOptions: [
          {
            name: "Organic",
            subOptionDescription:
              "Flowing, biomorphic, curved abstract forms inspired by shapes and patterns found in nature and plant life.",
            images: [
              "09177a15-b5af-4317-bd80-56d99ed9f6cc",
              "045d2f77-7d52-4b40-97ef-1d3c5f811014",
              "6436d404-e915-4752-9746-f78160083a04",
              "080643f4-7423-474e-bb1b-636d2edc58e9",
            ],
          },
          {
            name: "Geometric",
            subOptionDescription:
              "Abstract artistic compositions made up of geometric shapes like circles, squares, triangles arranged in sharp, hard edges.",
            images: [
              "a7d2d168-656f-42a2-aa0a-1e7cdb17565e",
              "62302c85-a72b-4b09-9b04-4ec463db548c",
              "c7edd729-275d-4787-9dd8-f22cb6cc58cf",
              "f4dd81aa-841d-4aae-a641-80d78583f3d2",
            ],
          },
        ],
      },
      // **************************************************** //
      {
        name: "Figurative",
        description:
          "Art representing discernible objects like the human figure, portraits, or other recognizable scenes and subject matter.",
        images: [
          "1bb9dd67-dacf-4bc0-ab09-beddd2531f85",
          "1fe854f9-9d13-49db-a747-b9902b2486d2",
          "71e45fb0-3733-42ec-8842-eed884b59395",
          "d89570cc-5ff8-430f-a572-7fe7295a81da",
        ],
        subOptions: [
          {
            name: "Single Portrait",
            subOptionDescription:
              "A solitary individual subject depicted in a portrait composition, focusing on their face, expression, and personality.",
            images: [
              "71e45fb0-3733-42ec-8842-eed884b59395",
              "1fe854f9-9d13-49db-a747-b9902b2486d2",
              "6bc2695e-829d-42df-99af-0200dd8c92d9",
              "8f8affe0-e481-4e7f-a3b8-ff3da9cb57a4",
            ],
          },
          {
            name: "Family",
            subOptionDescription:
              "Two or more figures together in a portrait, often parents and children or relatives, interacting and relating to each other.",
            images: [
              "fbb55042-4c1b-4aa6-a4b9-92f05082bad2",
              "667b4b31-ff2f-495b-bb9c-72b1c9580dc1",
              "b4805551-6cdc-486b-99ea-a6b45683ec89",
              "15b2c85a-8d00-4e55-994a-47703e568fd9",
            ],
          },
        ],
      },
      // **************************************************** //
      {
        name: "Landscape",
        description:
          "Natural scenery including both panoramic vistas and intimate scenes. Focuses on the beauty, light, and character of the landscape setting as the primary subject matter.",
        images: [
          "2d989b64-f99f-4c46-bb17-dec95191d412",
          "6d9f55c8-8ee0-4faf-804a-51c9a96cbbcb",
          "1d16cf74-d279-441a-9a9d-c60be8d4a1ad",
          "70e84b32-6728-4369-8ca9-0bfbbb079c61",
        ],
        subOptions: [
          {
            name: "Seascape",
            subOptionDescription:
              "Ocean, sea, or coastal view as the main subject, with waves, boats, and a beach often included.",
            images: [
              "8a9cc632-a4c2-41cb-b287-74aa37fdc1f3",
              "c9b0305c-5e79-49db-a802-4ee4680b331c",
              "373aaca1-12f1-47dd-8c21-99c4dc38575e",
              "c6be46ea-73ea-46f2-9e6f-9da6325297c4",
            ],
          },
          {
            name: "Cityscape",
            subOptionDescription:
              "Buildings, skyscrapers, streets, and other architectural and city views depicted in detail.",
            images: [
              "98a60099-dc83-4453-8542-cc48d0921139",
              "126837db-adc2-4780-8789-3834a5cdb5cc",
              "d09fb267-2365-409d-a3d0-89fff7cb63da",
              "d8b0cb3e-fafe-4d7d-8225-3a1bf5bb8081",
            ],
          },
          {
            name: "Mountainscape",
            subOptionDescription:
              "Mountainous landscape, focusing on the majestic peaks, cliffs, valleys, and overall scenery of the mountains.",
            images: [
              "a453e0f6-6ed3-40b2-9434-7e14550c0776",
              "11843e52-96e8-4d3e-b2ec-44bd18facae2",
              "c7010ba4-7365-4697-843c-e31bc97d4865",
              "bbf23e25-642a-488a-913c-b6b33b9554e5",
            ],
          },
          {
            name: "Skyscape",
            subOptionDescription:
              "Sky as the primary subject and backdrop, with clouds, weather, time of day, and atmospheric effects featured.",
            images: [
              "177635c2-694b-4db1-b18a-735c959ee9ba",
              "a7435729-6fb9-400d-960a-2458da02daf2",
              "a4706218-aee1-4989-a616-ae6956838a55",
              "87961a2b-3d05-4098-a501-013fc0133dbe",
            ],
          },
          {
            name: "Land",
            subOptionDescription:
              "Scenery of land can include mountains, hills, valleys, rivers, lakes, forests, fields, deserts.",
            images: [
              "2d989b64-f99f-4c46-bb17-dec95191d412",
              "6d9f55c8-8ee0-4faf-804a-51c9a96cbbcb",
              "1d16cf74-d279-441a-9a9d-c60be8d4a1ad",
              "70e84b32-6728-4369-8ca9-0bfbbb079c61",
            ],
          },
        ],
      },
      // **************************************************** //
      {
        name: "Still Life",
        description:
          "Depictions of inanimate common objects like fruit, flowers, bowls, household items, and other things arranged in a composed setup.",
        images: [
          "1fd8d039-95f0-45a4-9647-10070a14a191",
          "63c8554d-6d9f-47de-8adf-1f27efaf5f08",
          "ce06033c-e24c-44ef-addb-6701a173aa93",
          "cf98626f-dede-4f80-8ec4-50438e7e6f0b",
        ],
        subOptions: [
          {
            name: "Flowers",
            subOptionDescription:
              "Picturesque arrangement or display of various types of flowers in a particular setting or location. It is a composition of blooming plants, whether natural or intentionally arranged, that is designed to create an aesthetically pleasing and harmonious visual experience.",
            images: [
              "9f432c3f-87b9-4730-8da3-c20cca0cb391",
              "8ab48a8a-a82d-4ffc-a4fc-b45c9783203e",
              "0fa2da8b-cc54-442c-a269-dbe071428a60",
              "38d08e7f-607d-44f7-a050-ba47e38a2da3",
            ],
          },
          {
            name: "Household Items",
            subOptionDescription:
              "Depictions of inanimate common objects like fruit, flowers, bowls, household items, and other things arranged in a composed setup.",
            images: [
              "8309933c-655a-4f0d-b7f2-1ce4ee5a8f25",
              "58c1c2b8-0fc0-470a-9804-201885fbb54d",
              "ce06033c-e24c-44ef-addb-6701a173aa93",
              "d7253901-1ba0-4b38-b9ab-370f73965f4f",
            ],
          },
          {
            name: "Animals",
            subOptionDescription:
              "Various animals, wildlife, pets, and other beasts as the primary focus, in their natural or domestic settings.",
            images: [
              "789e54b3-b2e3-41f3-b4f0-cfe288294e43",
              "0992d687-7baf-49c8-8d4f-7bf9a05b75ca",
              "1238f431-4900-4218-94ef-948951344eb1",
              "9f2016d4-8484-42e9-b329-fdac154ec171",
            ],
          },
        ],
      },
    ],
  },
  {
    category: "Medium",
    title: "Choose Your Medium",
    subheader:
      "Is there a specific medium that will help define the look and texture of your art?",
    options: [
      {
        name: "Oil",
        description:
          "Rich, thick, and smooth oil paint allows for blending, glazing, and impasto brushwork to create lush optical mixes and fine textured effects.",
        images: [
          "ce311ceb-83c9-43e6-a7c1-f4aa99924fca",
          "d869555d-272a-4d5d-a040-7a645596f89b",
          "ce06033c-e24c-44ef-addb-6701a173aa93",
          "4c0df257-e5fd-4069-a8d6-8e7a4d9d22c1",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      // **************************************************** //
      {
        name: "Watercolor",
        description:
          "Translucent, water-soluble paint flows smoothly wet into wet for soft, feathery washes of color that evoke atmospheric landscapes, lighting, and ephemeral effects.",
        images: [
          "3551709c-f36b-4a79-9025-b642ff1202ce",
          "db8ac20a-1452-446d-bc19-05deb782e08a",
          "e71f092d-efe1-47c5-a7fd-5df480b4446d",
          "cec97ead-9fa7-494d-883d-a0c00fb98a52",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      // **************************************************** //
      {
        name: "Pastel",
        description:
          "Pure, powdery pigment sticks are blended, scumbled, and overlaid to build up organic textures, colors, and effects with a velvety softness.",
        images: [
          "0f42d334-3f86-4fec-b12e-4248613ddac9",
          "45b0bfad-7135-43e5-bca6-2639da8e9b47",
          "d52ae3bc-0b48-4b05-a8b8-dcc9c0d2c00b",
          "e9c37a8c-4346-4625-a43e-de4ee2bf029f",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      // **************************************************** //
      {
        name: "Pencil",
        description:
          "Graphite ranging from hard to soft allows for nuanced detailing, fine contours, smooth shading, highlights, and tonal gradations.",
        images: [
          "0ef95354-6605-406a-a261-8706e8571981",
          "78caf38e-2e21-4970-bd6d-99a092f72a49",
          "94b59d82-3932-4469-8a95-0ca713779068",
          "ca87f497-a47b-4dc3-b09a-0f6a9e4d3e4d",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      // **************************************************** //
      {
        name: "Ink",
        description:
          "Liquid color allows for spontaneous, vibrant marks and crisp details, contours, and textures.",
        images: [
          "47fd61e6-380b-4d27-90a1-c40d4176d60d",
          "3b95ffc4-456f-4296-8ca7-10f4cf429d5b",
          "2a6f4372-b1cb-451a-9f7a-bbd028cbab01",
          "fac8e8c0-40ab-4ea1-93b3-63baf56dfdc4",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
    ],
  },
  {
    category: "Styles",
    title: "Choose Your Style",
    subheader: "Is there a style or period in art history that you would like?",
    options: [
      {
        name: "Abstract Expressionism",
        description:
          "American painting style of the 1950s and 1960s, based primarily in NY, in which artists took the canvas off the traditional easel, embraced complete abstraction and reveled in showing the process and action of painting.",
        images: [
          "09fbbab6-afcd-4c29-9695-b68e87f520f0",
          "28a5e60c-fa46-4ba8-8423-c5e86d8e2d59",
          "a1341e02-0174-4005-ae73-3d7c1e1fad6f",
          "a5168162-fd3c-4d20-8b15-110bd3e052e3",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      // **************************************************** //
      {
        name: "Minimalism",
        description:
          "A style in American Art dating from the early 1960s that rejected representation, instead relying on simple forms and lines to create sensations and challenge the viewer’s relationship to the space around them.",
        images: [
          "9005e3e3-5718-4238-9dc2-40d7282eba0d",
          "37165b12-45af-4471-a978-aef2ecc61251",
          "463625e2-a988-4f3d-ad5f-d9e11c74e3d6",
          "8a9cc632-a4c2-41cb-b287-74aa37fdc1f3",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      // **************************************************** //
      {
        name: "Impressionism",
        description:
          "A style which began in Paris in the 1870s, in which artists abandoned the studio set-up to paint outdoors and capture the spontaneity of a given moment. The works of the Impressionists was characterized by large brushstrokes and effusive color.",
        images: [
          "76345223-9f82-45cc-bfb1-e8371f0e3416",
          "579e4206-99ae-438a-9756-95105578d8c2",
          "9e319ac0-d55f-4dfc-a682-9019041d4ac3",
          "9e463ea8-e1a0-44d7-8b61-9f3b720811df",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Precisionism",
        description:
          "A style in American Art directly following World War I which reduced subjects to their elemental shapes and forms. Precisionist works are characterized by stylized interpretations of light and a machine aesthetic.",
        images: [
          "5824a8e1-ca3f-4585-b2d2-db5d1aee035d",
          "8713217d-22f1-428c-bf60-2176329551b0",
          "baef3ecd-3891-44b5-8eb0-6c12b7eb2372",
          "d2c6194e-e881-450a-8c4d-fd1785c914ae",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Harlem Renaissance",
        description:
          "Dating to the 1920s and 1930s, situated primarily in the Harlem neighborhood in New York City, this African American art style revolutionized the artistic approach to figuration through the use of bold color, cubistic forms and intricate patterns.",
        images: [
          "50f4bfe0-7ea3-48c8-9d57-579a672f6ddd",
          "45b0bfad-7135-43e5-bca6-2639da8e9b47",
          "44bde18e-14a1-4615-95f5-b76c781f1a18",
          "f042cecb-fc1b-4ff0-8e94-7ef912d97842",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Surrealism",
        description:
          "An artistic and literary style which was centered in Paris and lasted from the early 1920s through World War II, characterized by an exploration of the subconscious, and the creation of fantastical dreamworlds.",
        images: [
          "2a39d875-f06c-4a62-9b10-76c45c9d01f3",
          "2141f84f-8766-483c-b178-9354153c621d",
          "e66627f2-5a57-4190-9d8d-b22f11fddb4a",
          "01358e77-2289-47e5-a4b0-6cab58cdaa88",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Deconstructivism",
        description:
          "An architectural style of the 1980s and 1990s characterized by distorted forms and illogical angles.",
        images: [
          "687f40ca-8f62-4da5-85e9-5474b348fa17",
          "e8020fe5-2365-4861-ab8b-b60c6701ea57",
          "b3bc9338-3b81-4c10-a265-86b6fa9e84f0",
          "da4e2ecb-463b-4fa7-8cdf-d6f872a233fa",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Graffiti",
        description:
          "A street art style which took hold in New York in the 1970s, characterized by the use of commercial paint and spray paint on prohibited outdoor surfaces. The work often invokes social commentary while employing bright and explosive color.",
        images: [
          "b125c62e-92a2-45aa-b2b1-98be5fb897c6",
          "f6ceba49-3625-4ea6-a6ba-6a59ec0d6bcd",
          "09177a15-b5af-4317-bd80-56d99ed9f6cc",
          "0d5cac0c-f268-4cf4-855c-93475bf21cc9",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Pop",
        description:
          "An art style which took hold by the 1950s in Britain and America, characterized by an embrace of the everyday images of life and an engagement with popular culture and mass media.",
        images: [
          "89f0964e-3166-405f-9b49-e64d181380eb",
          "f9aa8c81-81c9-489c-906f-fcb704c7a4c2",
          "8cab5293-4eef-4850-b37a-d74ef1bb54d7",
          "02b2cc6b-ff54-4c03-ad5d-cf22d01aa6d8",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Photorealism",
        description:
          "An American painting style which followed upon the tenets of Pop Art in its lionizing of everyday imagery. Photorealists painted in painstaking detail imagery based off of photographs.",
        images: [
          "8b63b541-e028-4dcb-9bf8-211aedc10a7b",
          "87961a2b-3d05-4098-a501-013fc0133dbe",
          "bf5da43d-ee4b-4c33-87a3-72f02002535e",
          "123af914-e8c6-4a48-8007-8f6329981497",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Op Art",
        description:
          "The style of Optical Art came to prominence in the 1960s and focused on the creation of optical illusions through the use of repeated lines and shapes, often in black and white or vivid colors.",
        images: [
          "8bd3a730-ecdc-4cb4-bfd9-dab39c4a0fe1",
          "c8e6bf79-f7a2-4d74-9960-084513c22f24",
          "c57125fa-2ab1-48dc-9e2b-bde9fd34f46f",
          "cf1d7294-b123-40c5-aca8-6c9ad8b68552",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Dadaism",
        description:
          "An “anti-art” style which arose across Europe and in New York in the years following World War I and lasting through the mid-1920s, which sought to disassemble the classic forms of representation that had previously dominated art history, and replaced them with novel uses of imagery and text.",
        images: [
          "6105ab7b-fb22-473d-9971-52fbad6c0594",
          "9b2ef8e2-d39b-4c25-ab8d-17536c4d8085",
          "e68e2f21-a959-4993-aa96-5d9409393044",
          "fea147e4-8d0a-42bf-a5c0-cb5c56b8252c",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Magic Realism",
        description:
          "A style which weaves through much of European and American art of the 20th century, specifically arising from German art of the 1920s. Similar to Surrealism, Magic Realism is characterized by a blurring of the line between reality and fantasy.",
        images: [
          "76af7ab8-eec8-4a88-81f0-9177091ded1f",
          "9dedd2b5-b35f-4468-bad4-c0f2f8c4ce1f",
          "2842eb82-39e3-458a-b28f-e6bff9b4e57e",
          "edb5da0b-13ec-4f12-ad63-82b1ddaf45e2",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Bauhaus",
        description:
          "A school of design and avant-garde art active in Germany from 1919 to 1933. The Bauhaus aesthetic redefined a modern taste through the use of sleek lines and limited color palette.",
        images: [
          "50f4bfe0-7ea3-48c8-9d57-579a672f6ddd",
          "41562837-f74f-4c4b-bd96-bb4a8f34321a",
          "63da2552-25c6-4b78-a8c2-14dd3e7f4225",
          "e9e67aad-fb42-4be4-b531-d8b837838521",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Art Deco",
        description:
          "A European and American style of the 1920s and 1930s that spanned art, architecture and furniture. The style focused on hard geometries, taking its cue from Cubism of the prior decade.",
        images: [
          "35fa3f19-d6b2-478b-ac6c-613b361c8b33",
          "5457a997-90bf-4203-8a93-df66c397901e",
          "5690fb59-f341-49c3-bb9c-4d1d23e6b60c",
          "921352a1-5eb5-4e62-aa99-41b529f98d1c",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "De Stijl",
        description:
          "A Dutch style of the 1920s which embraced total abstraction, strict geometries and the use of primary colors.",
        images: [
          "275fbfd1-3406-4387-b688-b7b17d55779f",
          "390e6594-45d9-4a05-82fa-c72461ce021c",
          "596d7fa1-a8ed-474d-90a5-b2b4730bce20",
          "773a9efd-c131-4b93-82e3-044692fed52d",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Orphism",
        description:
          "An abstract painting style primarily in France in the 1920s, characterized by circular forms and influenced by Cubism of the prior decade.",
        images: [
          "1a94baaf-ac23-4922-9362-835b0edcc435",
          "f5feb000-9616-4a8b-a8b2-44f590cb7731",
          "dfb8873e-0868-480f-8eac-e92bc739e6aa",
          "4f5cc3ec-d954-4754-b2fe-6f38dfe42c7c",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Cubism",
        description:
          "A revolution in Modern art, centered in Paris between 1908 and 1914, which sought to capture multiple viewpoints of the same subject on the static picture plane, often deconstructing its subject into fragmented squares.",
        images: [
          "7ca8edb3-b039-4fbd-999e-50a6d4ab64eb",
          "c80b33d6-062e-4833-9097-db73eddb12a4",
          "75b647d2-d2d4-4c56-9de7-d898cf5bd5f2",
          "44907e8d-0b10-4024-b6c8-dc4b5bd8cab2",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "German Expressionism",
        description:
          "A style situated in Germany in the first decades of the twentieth century, characterized by the artist’s expression of inner sentiments as opposed to a factual representation of reality. Often imbued with strong color and dynamic brushwork.",
        images: [
          "dc5b1f98-1951-4ee5-a7cc-b275c1d78da1",
          "713b6a3c-497a-4aa6-a982-7bc678250b3a",
          "7b276879-c292-4ea7-a490-80648255ce7d",
          "ebdebc0a-8e01-4b8b-b3b6-eb130833c2ab",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Fauvism",
        description:
          "A French style in painting initiated in 1905, and characterized by a wild use of color and gestural brushwork.",
        images: [
          "e18adfc1-4d65-471d-9c71-1c448414353f",
          "5ae02f93-431c-4c8f-b4bc-4c1fa82645e9",
          "24de9890-c002-4daf-8161-cb93a7620ade",
          "7ec01f92-88c0-41f3-86e5-25f423535d18",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Art Nouveau",
        description:
          "A style that took hold in the 1890s, on an international scale, which was characterized by curvilinear shapes and organic, plantlike forms.",
        images: [
          "c324afa3-b21a-4c35-971a-633731ed15dc",
          "e802a982-474c-4d9a-aeb9-89ce3c65a9b6",
          "7da56993-8031-4a24-b7c9-fb6811669e8a",
          "ef64baea-5a29-4c07-b314-f2cd6fc1469c",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Pointillism",
        description:
          "A post-Impressionist style in Europe during the 1890s, characterized by the use of minute dots of color and a scientific approach to the optics of color-apprehension.",
        images: [
          "c72a4523-0c6c-42c8-90a8-c47d2e37d2a6",
          "0e92db3c-5bb7-49fd-817b-fe61f97a39d0",
          "9d74a83e-5654-459d-a78d-a97655931b4b",
          "5e645c8c-4f49-4cfb-ab61-83027070e4b8",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Romanticism",
        description:
          "A style in early 19th century Europe characterized by a heightened sensibility to emotion in artistic creation and a keen interest in the natural world.",
        images: [
          "c9af7f49-4837-426b-ac68-8ca51af57786",
          "d1461b46-4693-49c9-a0d1-9a2172499269",
          "4459049d-8472-4423-8a2c-be0a3a2d0dab",
          "a7515a9e-89fb-44b1-b68a-c0274aba096f",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Realism",
        description:
          "Referring to the 19th century style in French art characterized by a high fidelity to detail in a given subject matter, ranging from still-life to genre painting.",
        images: [
          "ac421234-f47e-44a8-a1b4-c6b7039277a5",
          "9212768b-ab92-4264-a057-8866d81fd6b9",
          "5ebbc811-8ec0-43f6-911f-3441bc07f974",
          "d671190c-bd98-4ebc-83bf-71a2131aabf2",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Vienna Secession",
        description:
          "A style in the late 1890s in Vienna heralded by a group of artists that left the mainstream styles of the time to embrace decorative, stylized surfaces for their portraits and landscapes.",
        images: [
          "e919c800-739d-4bc2-ae57-f3d024de2cda",
          "d38c5a2d-c51d-487b-8d92-0d1d958adfe9",
          "7936d02f-1220-457f-bd36-a5fb0324c2ed",
          "8d139b18-492d-4e8c-9082-7ea6a0f5cbb7",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Luminism",
        description:
          "American landscape painting of the mid 19th century, centered around the Hudson River School, and focused on how the artist can portray light in the natural landscape.",
        images: [
          "a7515a9e-89fb-44b1-b68a-c0274aba096f",
          "661903a6-3868-4194-bf49-f406aeb9546a",
          "cc47780c-906a-487f-95e0-4f15f39c8d94",
          "67459296-abe3-4c13-9cdf-289ca6f65524",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Baroque",
        description:
          "Art of the 17th century European Baroque period was characterized by bold realism and a flair for the dramatic.",
        images: [
          "5a384c38-67d8-40c9-afbe-6e6242078def",
          "0e3a65b3-2ac0-4b44-9ca5-c7ab5bb3c845",
          "350bfde6-cc51-4c44-a54c-ca0bd788b925",
          "a8c2036c-4322-4da1-a84e-d70b85956de5",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Mannerism",
        description:
          "A 16th century European style which came in the wake of Renaissance. Mannerist painting was characterized by sinuous distortions of the human figure, and high-keyed color palettes that ventured from realistic portrayals.",
        images: [
          "f65649c2-382f-4573-b918-e61247cedc30",
          "769a99f8-570e-4d08-a65c-86432b7e6f0c",
          "615b23ef-d8dc-445d-9c27-cdae7e16d0ee",
          "2dfa100c-f3fe-47ba-b33e-b89caf8b8290",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Classicism",
        description:
          "Art that references Greco-Roman precedents, which became widely used by 17th century Europeans.",
        images: [
          "dafe9759-ca6d-478c-977b-6f9f0a0c984b",
          "59a6fc6b-06c3-4872-844f-3ff8359d4fa6",
          "360b7e18-d68d-4b19-9fdc-b3678aec9023",
          "bf8bea27-ae6b-457d-9149-a2e894fe201e",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Italian Renaissance",
        description:
          "The Italian version of Renaissance period in art, extending from the 1400s through the 1600s, peaking in the early years of the 1500s. In Italy, this style was characterized by a rediscovery of Classical forms and idealized versions of figures and places.",
        images: [
          "8309933c-655a-4f0d-b7f2-1ce4ee5a8f25",
          "2e4492ac-8a35-4379-af8d-0583cbfe5a92",
          "fa855112-5d25-4738-9448-752090d8cc73",
          "6893d570-a9c6-4b4c-a02c-3b2c1c2e3b2a",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Gothic",
        description:
          "A high-Medieval period in art and architecture which took hold by the 12th century and extended over several centuries of European history. Subjects extended from religious to secular subject matters, with rich coloration and a developing realism in painting.",
        images: [
          "16148c24-13c0-4597-9f3a-a17d78b91118",
          "75904734-1c2d-4b75-b9b5-1b48183077f4",
          "041c0cbc-b37c-4fd9-9e13-24ea48beaca7",
          "a5c16e90-bebc-4434-bc36-1dd25c97fc6f",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
    ],
  },
  {
    category: "Color",
    title: "Choose Your Color",
    subheader: "Is there a color mood or tone you are looking for?",
    freeText: ["dgdgsg", "ddgadg"],
    options: [
      {
        name: "Warm",
        description:
          "Reds, oranges, yellows create a heated, energetic mood; evokes passion and excitement.",
        images: [
          "76345223-9f82-45cc-bfb1-e8371f0e3416",
          "71e45fb0-3733-42ec-8842-eed884b59395",
          "972e4f8e-96ef-4c5b-b022-a085cd7b3762",
          "29344c15-dade-45bf-a828-698d0a3b5e81",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Cool",
        description:
          "Blues, greens, purples create a calm, tranquil mood; peaceful, relaxed, and serene.",
        images: [
          "0d415586-7aa9-4a0f-a080-5fe994984664",
          "6b088f7a-a2e5-441a-9369-a13ef4d55451",
          "6d31127e-b10c-4351-a61d-0890063d4a47",
          "7f1fdb06-0ffe-4601-8292-07dbad4c833b",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Bright",
        description:
          "Vivid, saturated hues create an energetic, lively mood; youthful and playful.",
        images: [
          "3e9d592c-6ee2-4920-bb1d-387aba603415",
          "93862407-c70f-45e6-b157-4231071db1ad",
          "05cef384-8459-43fa-bdfd-6143a5b3a4b8",
          "a0901c5f-3b1b-403b-a303-8e8170972912",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Dark",
        description:
          "Deep, muted shades create an elegant, mysterious mood; sophisticated and intimate.",
        images: [
          "2def76f0-4330-4d4d-9909-f485f2aca3aa",
          "3e03541e-2e15-4106-9e55-077787315e83",
          "fea147e4-8d0a-42bf-a5c0-cb5c56b8252c",
          "0a0c4ec2-cdd2-4033-ab0f-ffd8a2426330",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Soft",
        description:
          "Pale, muted tones create a gentle, delicate mood; ethereal and romantic.",
        images: [
          "aa244777-6b2c-4710-9880-809e98184c7d",
          "4fc7084d-f72e-41a2-9197-6f12fa7fd0a6",
          "8c852cb8-f5dd-4821-be58-db7e31414e71",
          "7bd1eeb9-b770-4429-af2f-67c460746bde",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
      {
        name: "Neutral",
        description:
          "Browns, greys, blacks, and whites are classic, versatile tones; simple and understated.",
        images: [
          "1f6942fa-b1de-43c5-b73c-28220310733f",
          "2d617e92-083d-4bb8-bb20-a7b1e727f290",
          "5ada3d8c-323c-4dcf-908c-257c37d9f21c",
          "5ebbc811-8ec0-43f6-911f-3441bc07f974",
        ],
        subOptions: [
          {
            name: "",
            subOptionDescription: "",
            images: [],
          },
        ],
      },
    ],
  },
];

export const badWords = [
  "Hell",
  "stupid",
  "loser",
  "retard",
  "lmao",
  "lmfao",
  "a55",
  "a55hole",
  "aeolus",
  "ahole",
  "anal",
  "analprobe",
  "anilingus",
  "anus",
  "areola",
  "areole",
  "arian",
  "aryan",
  "ass",
  "assbang",
  "assbanged",
  "assbangs",
  "asses",
  "assfuck",
  "assfucker",
  "assh0le",
  "asshat",
  "assho1e",
  "ass hole",
  "assholes",
  "assmaster",
  "assmunch",
  "asswipe",
  "asswipes",
  "azazel",
  "azz",
  "b1tch",
  "babe",
  "babes",
  "ballsack",
  "bang",
  "banger",
  "barf",
  "bastard",
  "bastards",
  "bawdy",
  "beaner",
  "beardedclam",
  "beastiality",
  "beatch",
  "beater",
  "beaver",
  "beer",
  "beeyotch",
  "beotch",
  "biatch",
  "bigtits",
  "big tits",
  "bimbo",
  "bitch",
  "bitched",
  "bitches",
  "bitchy",
  "blow job",
  "blow",
  "blowjob",
  "blowjobs",
  "bod",
  "bodily",
  "boink",
  "bollock",
  "bollocks",
  "bollok",
  "bone",
  "boned",
  "boner",
  "boners",
  "bong",
  "boob",
  "boobies",
  "boobs",
  "booby",
  "booger",
  "bookie",
  "bootee",
  "bootie",
  "booty",
  "booze",
  "boozer",
  "boozy",
  "bosom",
  "bosomy",
  "bowel",
  "bowels",
  "bra",
  "brassiere",
  "breast",
  "breasts",
  "bugger",
  "bukkake",
  "bullshit",
  "bull shit",
  "bullshits",
  "bullshitted",
  "bullturds",
  "bung",
  "busty",
  "butt",
  "butt fuck",
  "buttfuck",
  "buttfucker",
  "buttfucker",
  "buttplug",
  "c.0.c.k",
  "c.o.c.k.",
  "c.u.n.t",
  "c0ck",
  "c-0-c-k",
  "caca",
  "cahone",
  "cameltoe",
  "carpetmuncher",
  "cawk",
  "cervix",
  "chinc",
  "chincs",
  "chink",
  "chink",
  "chode",
  "chodes",
  "cl1t",
  "climax",
  "clit",
  "clitoris",
  "clitorus",
  "clits,clitty",
  "cocain",
  "cocaine",
  "cock",
  "c-o-c-k",
  "cockblock",
  "cockholster",
  "cockknocker",
  "cocks",
  "cocksmoker",
  "cocksucker",
  "cock sucker",
  "coital",
  "commie",
  "condom",
  "coon",
  "coons",
  "corksucker",
  "crabs",
  "crack",
  "cracker",
  "crackwhore",
  "crap",
  "crappy",
  "cum",
  "cummin",
  "cumming",
  "cumshot",
  "cumshots",
  "cumslut",
  "cumstain",
  "cunilingus",
  "cunnilingus",
  "cunny",
  "cunt",
  "cunt",
  "c-u-n-t",
  "cuntface",
  "cunthunter",
  "cuntlick",
  "cuntlicker",
  "cunts",
  "d0ng",
  "d0uch3",
  "d0uche",
  "d1ck",
  "d1ld0",
  "d1ldo",
  "dago",
  "dagos",
  "dammit",
  "damn",
  "damned",
  "damnit",
  "dawgie-style",
  "dick",
  "dickbag",
  "dickdipper",
  "dickface",
  "dickflipper",
  "dickhead",
  "dickheads",
  "dickish",
  "dick-ish",
  "dickripper",
  "dicksipper",
  "dickweed",
  "dickwhipper",
  "dickzipper",
  "diddle",
  "dike",
  "dildo",
  "dildos",
  "diligaf",
  "dillweed",
  "dimwit",
  "dingle",
  "dipship",
  "doggie-style",
  "doggy-style",
  "dong",
  "doofus",
  "doosh",
  "dopey",
  "douch3",
  "douche",
  "douchebag",
  "douchebags",
  "douchey",
  "drunk",
  "dumass",
  "dumbass",
  "dumbasses",
  "dummy",
  "dyke",
  "dykes",
  "ejaculate",
  "enlargement",
  "erect",
  "erection",
  "erotic",
  "essohbee",
  "extacy",
  "extasy",
  "f.u.c.k",
  "fack",
  "fag",
  "fagg",
  "fagged",
  "faggit",
  "faggot",
  "fagot",
  "fags",
  "faig",
  "faigt",
  "fannybandit",
  "fart",
  "fartknocker",
  "fat",
  "felch",
  "felcher",
  "felching",
  "fellate",
  "fellatio",
  "feltch",
  "feltcher",
  "fisted",
  "fisting",
  "fisty",
  "floozy",
  "foad",
  "fondle",
  "foobar",
  "foreskin",
  "freex",
  "frigg",
  "frigga",
  "fubar",
  "fuck",
  "f-u-c-k",
  "fuckass",
  "fucked",
  "fucked",
  "fucker",
  "fuckface",
  "fuckin",
  "fucking",
  "fucknugget",
  "fucknut",
  "fuckoff",
  "fucks",
  "fucktard",
  "fuck-tard",
  "fuckup",
  "fuckwad",
  "fuckwit",
  "fudgepacker",
  "fuk",
  "fvck",
  "fxck",
  "gae",
  "gai",
  "ganja",
  "gay",
  "gays",
  "gey",
  "gfy",
  "ghay",
  "ghey",
  "gigolo",
  "glans",
  "goatse",
  "godamn",
  "godamnit",
  "goddam",
  "goddammit",
  "goddamn",
  "goldenshower",
  "gonad",
  "gonads",
  "gook",
  "gooks",
  "gringo",
  "gspot",
  "g-spot",
  "gtfo",
  "guido",
  "h0m0",
  "h0mo",
  "handjob",
  "hard on",
  "he11",
  "hebe",
  "heeb",
  "hell",
  "hemp",
  "heroin",
  "herp",
  "herpes",
  "herpy",
  "hitler",
  "hiv",
  "hobag",
  "hom0",
  "homey",
  "homo",
  "homoey",
  "honky",
  "hooch",
  "hookah",
  "hooker",
  "hoor",
  "hootch",
  "hooter",
  "hooters",
  "horny",
  "hump",
  "humped",
  "humping",
  "hussy",
  "hymen",
  "inbred",
  "incest",
  "injun",
  "j3rk0ff",
  "jackass",
  "jackhole",
  "jackoff",
  "jap",
  "japs",
  "jerk",
  "jerk0ff",
  "jerked",
  "jerkoff",
  "jism",
  "jiz",
  "jizm",
  "jizz",
  "jizzed",
  "junkie",
  "junky",
  "kike",
  "kikes",
  "kill",
  "kinky",
  "kkk",
  "klan",
  "knobend",
  "kooch",
  "kooches",
  "kootch",
  "kraut",
  "kyke",
  "labia",
  "lech",
  "leper",
  "lesbians",
  "lesbo",
  "lesbos",
  "lez",
  "lezbian",
  "lezbians",
  "lezbo",
  "lezbos",
  "lezzie",
  "lezzies",
  "lezzy",
  "lmao",
  "lmfao",
  "loin",
  "loins",
  "lube",
  "lusty",
  "mams",
  "massa",
  "masterbate",
  "masterbating",
  "masterbation",
  "masturbate",
  "masturbating",
  "masturbation",
  "maxi",
  "menses",
  "menstruate",
  "menstruation",
  "meth",
  "m-fucking",
  "mofo",
  "molest",
  "moolie",
  "moron",
  "motherfucka",
  "motherfucker",
  "motherfucking",
  "mtherfucker",
  "mthrfucker",
  "mthrfucking",
  "muff",
  "muffdiver",
  "murder",
  "muthafuckaz",
  "muthafucker",
  "mutherfucker",
  "mutherfucking",
  "muthrfucking",
  "nad",
  "nads",
  "naked",
  "napalm",
  "nappy",
  "nazi",
  "nazism",
  "negro",
  "nigga",
  "niggah",
  "niggas",
  "niggaz",
  "nigger",
  "nigger",
  "niggers",
  "niggle",
  "niglet",
  "nimrod",
  "ninny",
  "nipple",
  "nooky",
  "nympho",
  "opiate",
  "opium",
  "oral",
  "orally",
  "organ",
  "orgasm",
  "orgasmic",
  "orgies",
  "orgy",
  "ovary",
  "ovum",
  "ovums",
  "p.u.s.s.y.",
  "paddy",
  "paki",
  "pantie",
  "panties",
  "panty",
  "pastie",
  "pasty",
  "pcp",
  "pecker",
  "pedo",
  "pedophile",
  "pedophilia",
  "pedophiliac",
  "pee",
  "peepee",
  "penetrate",
  "penetration",
  "penial",
  "penile",
  "penis",
  "perversion",
  "peyote",
  "phalli",
  "phallic",
  "phuck",
  "pillowbiter",
  "pimp",
  "pinko",
  "piss",
  "pissed",
  "pissoff",
  "piss-off",
  "pms",
  "polack",
  "pollock",
  "poon",
  "poontang",
  "porn",
  "porno",
  "pornography",
  "pot",
  "potty",
  "prick",
  "prig",
  "prostitute",
  "prude",
  "pube",
  "pubic",
  "pubis",
  "punkass",
  "punky",
  "puss",
  "pussies",
  "pussy",
  "pussypounder",
  "puto",
  "queaf",
  "queef",
  "queef",
  "queer",
  "queero",
  "queers",
  "quicky",
  "quim",
  "racy",
  "rape",
  "raped",
  "raper",
  "rapist",
  "raunch",
  "rectal",
  "rectum",
  "rectus",
  "reefer",
  "reetard",
  "reich",
  "retard",
  "retarded",
  "revue",
  "rimjob",
  "ritard",
  "rtard",
  "r-tard",
  "rum",
  "rump",
  "rumprammer",
  "ruski",
  "s.h.i.t.",
  "s.o.b.",
  "s0b",
  "sadism",
  "sadist",
  "scag",
  "scantily",
  "schizo",
  "schlong",
  "screw",
  "screwed",
  "scrog",
  "scrot",
  "scrote",
  "scrotum",
  "scrud",
  "scum",
  "seaman",
  "seamen",
  "seduce",
  "semen",
  "sex",
  "sexual",
  "sh1t",
  "s-h-1-t",
  "shamedame",
  "shit",
  "s-h-i-t",
  "shite",
  "shiteater",
  "shitface",
  "shithead",
  "shithole",
  "shithouse",
  "shits",
  "shitt",
  "shitted",
  "shitter",
  "shitty",
  "shiz",
  "sissy",
  "skag",
  "skank",
  "slave",
  "sleaze",
  "sleazy",
  "slut",
  "slutdumper",
  "slutkiss",
  "sluts",
  "smegma",
  "smut",
  "smutty",
  "snatch",
  "sniper",
  "snuff",
  "s-o-b",
  "sodom",
  "souse",
  "soused",
  "sperm",
  "spic",
  "spick",
  "spik",
  "spiks",
  "spooge",
  "spunk",
  "steamy",
  "stfu",
  "stiffy",
  "stoned",
  "strip",
  "stroke",
  "stupid",
  "suck",
  "sucked",
  "sucking",
  "sumofabiatch",
  "t1t",
  "tampon",
  "tard",
  "tawdry",
  "teabagging",
  "teat",
  "terd",
  "teste",
  "testee",
  "testes",
  "testicle",
  "testis",
  "thrust",
  "thug",
  "tinkle",
  "tit",
  "titfuck",
  "titi",
  "tits",
  "tittiefucker",
  "titties",
  "titty",
  "tittyfuck",
  "tittyfucker",
  "toke",
  "toots",
  "tramp",
  "transsexual",
  "trashy",
  "tubgirl",
  "turd",
  "tush",
  "twat",
  "twats",
  "ugly",
  "undies",
  "unwed",
  "urinal",
  "urine",
  "uterus",
  "uzi",
  "vag",
  "vagina",
  "valium",
  "viagra",
  "virgin",
  "vixen",
  "vodka",
  "vomit",
  "voyeur",
  "vulgar",
  "vulva",
  "wad",
  "wang",
  "wank",
  "wanker",
  "wazoo",
  "wedgie",
  "weed",
  "weenie",
  "weewee",
  "weiner",
  "weirdo",
  "wench",
  "wetback",
  "wh0re",
  "wh0reface",
  "whitey",
  "whiz",
  "whoralicious",
  "whore",
  "whorealicious",
  "whored",
  "whoreface",
  "whorehopper",
  "whorehouse",
  "whores",
  "whoring",
  "wigger",
  "womb",
  "woody",
  "wop",
  "wtf",
  "x-rated",
  "xxx",
  "yeasty",
  "yobbo",
  "zoophile",
  "pervy",
  "idiot",
];
